import React, { useRef } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
} from '@material-ui/core';
import styled from 'styled-components';
import { useFormSnackbarError, useRecentCallback } from '@lib/common';
import { useController } from 'react-hook-form';
import { startCase } from 'lodash';
import { useForm, FormProvider } from 'react-hook-form';
import { useCallback } from 'react';
import { PageLoading } from '@components/page-loading';
import { DealEntity } from '@lib/deals';
import { Autocomplete } from '@material-ui/lab';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useGetAllCognitoUsers } from '@lib/common';
import { companyMasterApi } from '@api/masters';
import { map } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { debounce } from 'lodash';

export function CreateEntityRequest({
  dealData,
  entityData,
  onOk = null,
  onCancel = null,
  open,
  onClose,
  loading = false,
}) {
  const dealSourceUrl = dealData.sentences
    .map(eachSentence => eachSentence.article.source_url)
    .join('|||');
  const dealId = dealData.id;
  const form = useForm({
    defaultValues: {
      deal_source: dealSourceUrl,
      deal_id: dealId,
      company_name: entityData,
      company_hq_country: '',
      company_type: '',
      tagged_usernames: [],
    },
    // resolver: vestResolver(dialogContentValidationSuite),
    reValidateMode: 'onSubmit',
  });
  const [onFinish] = useRecentCallback(dialogData => {
    onOk(dialogData);
  });

  const formError = useFormSnackbarError();

  const submitForm = form.handleSubmit(onFinish, formError);
  const fieldName = `dialogEntityRequest`;

  const DealSourceUrl = useCallback(() => {
    return (
      <ControlledTextField
        fullWidth
        // variant={vtrIdChosenForContent ? 'filled' : 'outlined'}
        variant={'outlined'}
        control={form.control}
        name="deal_source"
        label="Deal Source"
        defaultValue={dealSourceUrl}
        // disabled={vtrIdChosenForContent}
      />
    );
  }, []);
  const DealIdUrl = useCallback(() => {
    return (
      <ControlledTextField
        fullWidth
        // variant={vtrIdChosenForContent ? 'filled' : 'outlined'}
        variant={'outlined'}
        control={form.control}
        name="deal_id"
        label="Deal id"
        // disabled={vtrIdChosenForContent}
      />
    );
  }, []);
  const DealCompanyName = useCallback(() => {
    return (
      <ControlledTextField
        fullWidth
        // variant={vtrIdChosenForContent ? 'filled' : 'outlined'}
        variant={'outlined'}
        control={form.control}
        name="company_name"
        label="Company Name"
        // disabled={vtrIdChosenForContent}
      />
    );
  }, []);
  const DealCompanyType = useCallback(() => {
    return (
      <ControlledTextField
        fullWidth
        // variant={vtrIdChosenForContent ? 'filled' : 'outlined'}
        variant={'outlined'}
        control={form.control}
        name="company_type"
        label="Company Type"
        // disabled={vtrIdChosenForContent}
      />
    );
  }, []);

  const DealCompanyHQCountry = useCallback(() => {
    return (
      <ControlledTextField
        fullWidth
        // variant={vtrIdChosenForContent ? 'filled' : 'outlined'}
        variant={'outlined'}
        control={form.control}
        name="company_hq_country"
        label="Company HQCountry"
        // disabled={vtrIdChosenForContent}
      />
    );
  }, []);

  const TaggedCognitoUser = useCallback(() => {
    return <ControlledAutoCompleteField name="tagged_usernames" control={form.control} />;
  }, []);

  return (
    <FormProvider {...form}>
      <form onSubmit={submitForm}>
        <Dialog
          fullWidth
          maxWidth={'md'}
          open={open}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-content">Create Company Request</DialogTitle>
          <DialogContent dividers>
            <Box pb={3}>
              <Typography variant="button">Company Request Attributes</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <DealIdUrl />
              </Grid>
              <Grid item xs={6}>
                <DealSourceUrl />
              </Grid>
              <Grid item xs={6}>
                <DealCompanyName />
              </Grid>
              <Grid item xs={6}>
                <DealCompanyHQCountry />
              </Grid>
              <Grid item xs={6}>
                <DealCompanyType />
              </Grid>
              <Grid item xs={6}>
                <TaggedCognitoUser />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel} color="primary" disabled={loading}>
              Cancel
            </Button>
            <Button onClick={submitForm} color="primary" autoFocus disabled={loading}>
              {loading ? (
                <PageLoading style={{ height: 'unset' }} sizeOfCircularProgress={'30px'}>
                  {' '}
                </PageLoading>
              ) : (
                'Ok'
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </FormProvider>
  );
}

const ControlledTextField = ({ name, control, readonly = false, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
    // defaultValue: props.defaultValue ? props.defaultValue : null,
  });
  const callbackOnChange = useCallback(e => onChange(e.target.value), [onChange]);
  return (
    <TextField
      {...props}
      name={name}
      value={value}
      inputProps={{ readOnly: readonly }}
      onChange={callbackOnChange}
    />
  );
};

const PaddingBottomEntitySearch = styled.div`
  margin-bottom: 20px;
  :last-child {
    margin-bottom: 0px;
  }
  // & .MuiPaper-elevation3 {
  //   box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%) inset, 0px 3px 4px 0px rgb(0 0 0 / 14%) inset,
  //     0px 1px 8px 0px rgb(0 0 0 / 12%) inset, 0px 3px 3px -2px rgb(0 0 0 / 20%),
  //     0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
  // }

  // & .MuiPaper-elevation2 {
  //   box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%) inset, 0px 2px 2px 0px rgb(0 0 0 / 14%) inset,
  //     0px 1px 5px 0px rgb(0 0 0 / 12%) inset, 0px 3px 1px -2px rgb(0 0 0 / 20%),
  //     0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  // }
`;

const PaddingBottomFields = styled.div`
  margin-bottom: 0px;
`;

const createAttr = (
  readonly: boolean = false,
  key: keyof DealEntity,
  label: string = null,
  componentToShow: React.ReactNode = null
) => ({
  readonly: readonly,
  key,
  label: label ? label : startCase(key),
  component: componentToShow,
});

const ControlledAutoCompleteField = ({ name, control, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control });

  const lastSubscription = useRef<Subscription>(null);
  const lastSearchedvalue = useRef<string>(null);

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  // const { master: cognitoUsers, loading } = useGetAllCognitoUsers();
  const onChangeHandle = async value => {
    if (lastSearchedvalue.current && lastSearchedvalue.current == value && options.length > 0) {
      setOptions(prevOptions => [...prevOptions]);
      return;
    }
    setOptions([]);
    lastSearchedvalue.current = value;
    if (lastSubscription.current) {
      lastSubscription.current.unsubscribe();
    }
    setLoading(true);
    lastSubscription.current = companyMasterApi
      .allCognitoUsers(value)
      .pipe(
        map(res =>
          res.Users.filter(x => {
            const y = x.Attributes;
            const z = y.filter(y => y.Name == 'custom:authorities' && y.Value.includes('DELI'));
            if (z.length > 0) return true;
          }).map(x => x.Username)
        )
      )
      .subscribe({
        next: data => {
          setOptions(data);
        },
        error: data => {
          console.error(data, 'Error');
        },
        complete: () => {
          setLoading(false);
        },
      });
  };

  const debouncedOnChangeHandle = debounce(value => onChangeHandle(value), 2000);
  // const loading = open && options.length === 0;

  return (
    <Autocomplete
      value={value}
      multiple
      onChange={(evt, v) => onChange && onChange(v)}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      options={options}
      disableClearable
      loading={loading}
      loadingText={'Searching ... '}
      renderInput={props => (
        <TextField
          label="Tagged Users"
          fullWidth
          variant="outlined"
          {...props}
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <>
                    <CircularProgress color="inherit" size={20} />
                    {props.InputProps.endAdornment}
                  </>
                ) : null}
              </React.Fragment>
            ),
          }}
          onChange={ev => {
            // if (!!ev.target.value) {
            debouncedOnChangeHandle(ev.target.value);
            // }
          }}
          onFocus={ev => {
            // if (!!ev.target.value) {
            debouncedOnChangeHandle(ev.target.value);
            // }
          }}
        />
      )}
    />
  );
};
